<template>
  <div class="w-96">
      
      <a target="_blank" :href="item.link" 
           v-for="(item, index) in data" :key="index" class="block mb-4 text-center p-4" :style="{'background-color': item.bgcolor, 'color': item.color }">
          {{ item.title }}
          
          <div v-html="item.message"></div>
      </a>
      
      
  </div>
</template>

<script>
export default {
  name: "DriverPreview",
    
    props: [
        'data', 'app_locale'
    ],
    
    mounted() {
      console.log(this.data);
    }
    
}
</script>

<style scoped>

</style>
